import React from 'react';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import InputLabel from '../inputLabel/InputLabel';
import { ThemeColors } from '../../themes/online';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';

// tslint:disable-next-line:variable-name
const SDropdownWrap = styled.div<{ inputColor?: ThemeColors }>(
  ({ theme, inputColor }) => `
  position: relative;
  color :${inputColor ? theme.colors[inputColor] : 'inherit'};
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 800px) {
    flex-basis: 0;
  }
`
);

// tslint:disable-next-line:variable-name
const SDropdown = styled(Select)<{ error: boolean; inputColor?: ThemeColors; elementName?: string; dataTestId?: string; }>(({ theme, error, inputColor, elementName }) => {
  const controlClassName = `.${elementName}_dropDown__control`;
  const valueContainerClassName = `.${elementName}_dropDown__value-container`;
  const dropDownClassName = `.${elementName}.dropDown__placeholder`;
  return {
    position: 'relative',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    [controlClassName]: {
      backgroundColor: theme.colors.whiteGray,
      border: `1px solid ${error ? theme.colors.error : theme.colors.border}`,
      borderRadius: theme.borderRadiusCommon,
      position: 'relative',
      cursor: 'pointer',
      boxShadow: 'none' /* override  */,
      '&:hover': {
        border: `1px solid ${error ? theme.colors.error : theme.colors.border}` /* override  */,
      },
    },
    [valueContainerClassName]: {
      fontWeight: theme.font.weight.light,
      fontSize: theme.font.size.smallMedium2,
      boxSizing: 'border-box',
      color: theme.colors.grayDark,
      backgroundColor: 'transparent',
      borderWidth: 0,
      padding: `${theme.spacing.medium}px ${theme.spacing.large}px`,
      div: {
        color: `${inputColor ? theme.colors[inputColor] : theme.colors.grayDark}`,
        margin: 0,
        padding: 0,
        fontWeight: theme.font.weight.light,
        fontSize: theme.font.size.smallMedium2,
      },
      input: {
        width: '100%',
        appearance: 'none',
        outline: 'none',
        margin: 0,
        padding: 0,
        borderWidth: 0,
        fontSize: theme.font.size.smallMedium2,
      },
    },
    [dropDownClassName]: {
      fontWeight: theme.font.weight.light,
      color: `${theme.colors.placeholder} !important`,
      fontSize: theme.font.size.smallMedium2,
      position: 'absolute',
      margin: 0,
      top: 'auto',
      transform: 'initial',
      div: {
        margin: 0,
      },
    },
  };
});

export interface IDropdownOptionForSelect<T> {
  label: string;
  value: T;
}

export interface IDropdownProps<T> {
  onChange: (value: T, name: string) => void;
  name: string;
  placeholder?: string;
  value: T;
  dropdownOptions: Array<IDropdownOptionForSelect<T>>;
  dataAt?: string;
  className?: string;
  error?: string;
  dataTestId?: string;
  label?: string | React.ReactChild;
  inputColor?: ThemeColors;
}

export class Dropdown<T> extends React.Component<IDropdownProps<T>> {
  public handleOnChange = (selectedOption: IDropdownOptionForSelect<T>) => {
    this.props.onChange(selectedOption.value, this.props.name);
  };

  public render() {
    const {dataTestId} = this.props;

    const placeholder = this.props.placeholder || this.props.name.replace(/^\w/, (c) => c.toUpperCase());
    let selecedOption = null;

    if (this.props.value && this.props.dropdownOptions && this.props.dropdownOptions.length) {
      selecedOption = this.props.dropdownOptions.find((item) => item.value === this.props.value);
    }

    return (
      <SDropdownWrap inputColor={this.props.inputColor} data-at={`${this.props.dataAt}`} className={this.props.className}>
        {this.props.label && (
          <InputLabel color={this.props.inputColor} dataAt={`${this.props.dataAt}-label`}>
            {this.props.label}
          </InputLabel>
        )}
        <SDropdown
          elementName={this.props.dataAt}
          inputColor={this.props.inputColor}
          error={!!this.props.error}
          dataTestId={dataTestId}
          classNamePrefix={`${this.props.dataAt}_dropDown`}
          options={this.props.dropdownOptions}
          placeholder={placeholder}
          onChange={this.handleOnChange}
          value={selecedOption}
        />
      </SDropdownWrap>
    );
  }
}
